module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/notokr-bold.woff
// module id = 7cu9
// module chunks = 0